export const cardData  = [
  {
    logo: "/assets/images/icons/ship.webp",
    description: "Asia's first private institute with Ship-In-Campus for hands on experience",
  },
  {
    logo: "/assets/images/icons/placement.webp",
    description: "100% placement assitance by providing company specific training ",
  },
  {
    logo: "/assets/images/icons/technical_training.webp",
    description: "Special technical training given for building technical acumen in budding officers",
  },
  {
    logo: "/assets/images/icons/discipline.webp",
    description: "Well curated schedule to instill discipline, dedication and physical strength for all the cadets",
  },
  {
    logo: "/assets/images/icons/labs.webp",
    description: "Well equipped laboratories and simulators for better learning experience",
  },
  {
    logo: "/assets/images/icons/CIL_school.webp",
    description: "School of Corporate Innovation & Leadership for aptitude training & professional grooming",
  },
];
